import { CircularProgress } from '@mui/material';
import { Box } from '@mui/system';

export interface DefaultSuspenseFallbackProps {
  fullPage?: boolean;
}

function DefaultSuspenseFallback(props: DefaultSuspenseFallbackProps) {
  const { fullPage = false } = props;

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        height: fullPage ? '100vh' : 'auto',
        justifyContent: 'center',
        minHeight: 300,
      }}
    >
      <CircularProgress />
    </Box>
  );
}

export default DefaultSuspenseFallback;
